/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SubmissionOutputUploadSubmissionFile model module.
 * @module model/SubmissionOutputUploadSubmissionFile
 * @version 1.0
 */
class SubmissionOutputUploadSubmissionFile {
    /**
     * Constructs a new <code>SubmissionOutputUploadSubmissionFile</code>.
     * @alias module:model/SubmissionOutputUploadSubmissionFile
     */
    constructor() { 
        
        SubmissionOutputUploadSubmissionFile.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SubmissionOutputUploadSubmissionFile</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SubmissionOutputUploadSubmissionFile} obj Optional instance to populate.
     * @return {module:model/SubmissionOutputUploadSubmissionFile} The populated <code>SubmissionOutputUploadSubmissionFile</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SubmissionOutputUploadSubmissionFile();

            if (data.hasOwnProperty('filePath')) {
                obj['filePath'] = ApiClient.convertToType(data['filePath'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} filePath
 */
SubmissionOutputUploadSubmissionFile.prototype['filePath'] = undefined;






export default SubmissionOutputUploadSubmissionFile;

